import { useState } from "react";
import { FileWarning, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, money } from "@/lib/api";

export const ReclamationForm = ({ r, onSaved }) => {
  const rec = r.regularisation.reclamation;
  const [montant, setMontant] = useState(rec ? String(rec.montant).replace(".", ",") : "");
  const [objet, setObjet] = useState(rec?.objet || "");
  const [motif, setMotif] = useState(rec?.motif || "");
  const [busy, setBusy] = useState(false);
  const n = Number(montant.replace(/\s/g, "").replace(",", "."));
  const valide = n > 0 && objet.trim() && motif.trim();
  const save = async () => {
    setBusy(true);
    try { await api.put(`/reservations/${r.id}/reclamation`, { montant: n, objet, motif }); toast.success(`Réclamation de ${money(n)} enregistrée`); onSaved(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const retirer = async () => {
    try { await api.delete(`/reservations/${r.id}/reclamation`); toast.success("Réclamation retirée : la lettre reprend l'écart calculé"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2 rounded-md border border-amber-200 bg-amber-50/40 p-3" data-testid="reclamation-form">
      <div className="flex items-center gap-2">
        <FileWarning className="h-4 w-4 text-amber-700" />
        <p className="text-sm font-medium text-slate-800">Montant à réclamer</p>
        {rec && <span className="ml-auto text-xs text-amber-800" data-testid="reclamation-actuelle">Lettre actuelle : {money(rec.montant)}</span>}
      </div>
      <div className="flex gap-2">
        <div className="space-y-1"><Label className="text-xs">Montant</Label>
          <Input value={montant} onChange={(e) => setMontant(e.target.value)} inputMode="decimal" placeholder="0,00" className="h-9 w-28 text-right" data-testid="reclamation-montant-input" /></div>
        <div className="flex-1 space-y-1"><Label className="text-xs">Objet de la lettre</Label>
          <Input value={objet} maxLength={200} onChange={(e) => setObjet(e.target.value)} placeholder="Ex. : TPS manquante sur le versement" className="h-9" data-testid="reclamation-objet-input" /></div>
      </div>
      <Textarea rows={4} maxLength={4000} value={motif} onChange={(e) => setMotif(e.target.value)} placeholder="Expliquez pourquoi ce montant est dû (calcul, versement reçu, comparaison…)" data-testid="reclamation-motif-input" />
      <p className="text-[11px] text-slate-500">La lettre de contestation (PDF) reprendra ce montant et ce motif. Le statut passe à « Contestée » et une relance est prévue dans 30 jours si aucune date n'est fixée.</p>
      <div className="flex gap-2">
        <Button size="sm" className="h-8 bg-emerald-700 hover:bg-emerald-800" disabled={!valide || busy} onClick={save} data-testid="reclamation-save-button">
          {busy && <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />}Enregistrer la réclamation
        </Button>
        {rec && <Button size="sm" variant="ghost" className="h-8 text-slate-500 hover:text-red-600" onClick={retirer} data-testid="reclamation-delete-button"><Trash2 className="h-3.5 w-3.5 mr-1" />Retirer</Button>}
      </div>
    </div>
  );
};
